import { defineAsyncComponent } from 'vue'
import { RouteRecordRaw } from 'vue-router'

const routeStepWizardValues = {
  nmsHome: 0,
  nmsAyudas: 1,
  nmsOptionContact: 2,
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:version',
    name: 'nms',
    component: () => import('@/micro/views/IndexView.vue'),
    props: route => route.name && { step: routeStepWizardValues[route.name] },
    children: [
      {
        name: 'nmsHome',
        path: '',
        // component: () => import('@/micro/views/home/HomeView.vue'),
        component: defineAsyncComponent(() => import('@/micro/views/home/HomeView.vue')),
      },
      {
        name: 'nmsAyudas',
        path: 'helpers-results',
        // component: () => import('@/micro/views/helpers/HelpersView.vue'),
        component: defineAsyncComponent(() => import('@/micro/views/helpers/HelpersView.vue')),
      },
      {
        name: 'nmsOptionContact',
        path: 'contact-options',
        // component: () => import('@/micro/views/contact-options/ContactOptionsView.vue'),
        component: defineAsyncComponent(
          () => import('@/micro/views/contact-options/ContactOptionsView.vue'),
        ),
      },
    ],
  },
  {
    path: '/:catchAll(.*)*',
    redirect: '/:version/contact-options',
  },
]
export default routes
